import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=c4f3b1c6"
import script from "./LogoutModal.vue?vue&type=script&lang=ts"
export * from "./LogoutModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports